import { Component, h, Prop, State } from '@stencil/core';
import { gettrackmeEventCategory, gettrackmeEventObject } from '../../../utils/tracking-helpers';

type NewsItem = {
    image: { mq1: string; mq1r: string; mq2: string; mq2r: string; mq3: string; mq3r: string };
    imageAlt: string;
    imageTitle: string;
    headline: string;
    date: string;
    introText: string;
    linkUrl: string;
    linkTitle: string;
};

@Component({
    tag: 'sew-ws-news-api',
    shadow: false,
})
export class SewWsNewsApi {
    @Prop() url?: string = 'https://caas.sew-d.com/direct/SEWDE/news';
    @Prop() headline: string;

    @State() news: NewsItem[] = [];

    componentWillLoad(): void {
        const dateFilter = JSON.stringify({ timestamp: { $lt: Math.floor(Date.now() / 1000) } });
        fetch(`${this.url}&filter=${dateFilter}`)
            .then(response => {
                if (!response.ok) {
                    throw Error();
                }

                return response.json();
            })
            .then(json => {
                this.news = json['_embedded']['rh:doc'];
            })
            .catch(e => {
                console.log(e);
            });
    }

    render() {
        return this.news.length > 0 ? (
            <sew-ws-news headline={this.headline}>
                {this.news.map(item => {
                    return (
                        item.image && (
                            <sew-picture
                                slot="picture"
                                img-src={item.image.mq3}
                                img-alt={item.imageAlt}
                                img-title={item.imageTitle}
                            >
                                <source
                                    media="(min-width:1024px)"
                                    srcSet={item.image.mq3 + ' 1x, ' + item.image.mq3r + ' 2x'}
                                />
                                <source
                                    media="(min-width:768px)"
                                    srcSet={item.image.mq2 + ' 1x, ' + item.image.mq2r + ' 2x'}
                                />
                                <source
                                    media="(max-width:767px)"
                                    srcSet={item.image.mq1 + ' 1x, ' + item.image.mq1r + ' 2x'}
                                />
                            </sew-picture>
                        )
                    );
                })}
                {this.news.map(item => {
                    return (
                        <sew-ws-news-content headline={item.headline} date={item.date} text={item.introText}>
                            <a
                                href={item.linkUrl}
                                data-sew-trackme-event-category={gettrackmeEventCategory('News')}
                                data-sew-trackme-event-object={gettrackmeEventObject(item.linkTitle)}
                                data-sew-trackme-event-action="Click"
                            >
                                {item.linkTitle}
                            </a>
                        </sew-ws-news-content>
                    );
                })}
                <slot name="button"></slot>
            </sew-ws-news>
        ) : null;
    }
}
